export enum NamedPath {
  ADHOC_CORRECTIVE_WORK = "AdhocCorrectiveWork",
  ADHOC_REGULAR_WORK = "AdhocRegularWork",
  PLANNED_CORRECTIVE_WORK = "PlannedCorrectiveWork",
  PLANNED_REGULAR_WORK = "PlannedRegularWork",
  AREA = "Area",
  INDEX = "Index",
  INITIATE_APP = "InitiateApp",
  ISSUE = "Issue",
  ITEM = "Item",
  ITEM_MODEL = "ItemModel",
  LOCATION = "Location",
  LOCK = "Lock",
  LOGIN = "Login",
  PERFORMED_CORRECTIVE_WORK = "PerformedCorrectiveWork",
  PERFORMED_REGULAR_WORK = "PerformedRegularWork",
  SELECT_AREA = "SelectArea",
  SELECT_ISSUE = "SelectIssue",
  SELECT_ITEM = "SelectItem",
  SELECT_LAYOUT = "SelectLayout",
  SELECT_MODEL = "SelectModel",
  SELECT_PERFORMED_WORK = "SelectPerformedWork",
  SELECT_WORK_ORDER = "SelectWorkOrder",
  SELECT_WORKSPACE = "SelectWorkspace",
  SELECT_ZONE = "SelectZone",
  TO_DO = "ToDo",
  USER_SETTINGS = "UserSettings",
  WORK_ORDER_CORRECTIVE = "WorkOrderCorrective",
  WORK_ORDER_REGULAR = "WorkOrderRegular",
  WORKSPACE = "Workspace",
  ZONE = "Zone",
  NO_BROWSER = "NoBrowser",
}

export enum NamedManagerPath {
  ADHOC_CORRECTIVE_WORK = "AdhocCorrectiveWork",
  ADHOC_REGULAR_WORK = "AdhocRegularWork",
  AREA = "Area",
  CREATE_ISSUE = "CreateIssue",
  INDEX = "Index",
  INITIATE_APP = "InitiateApp",
  ISSUE = "Issue",
  ITEM = "Item",
  ITEM_MODEL = "ItemModel",
  LOCATION = "Location",
  LOCK = "Lock",
  LOGIN = "Login",
  PERFORMED_CORRECTIVE_WORK = "PerformedCorrectiveWork",
  PERFORMED_REGULAR_WORK = "PerformedRegularWork",
  SELECT_AREA = "SelectArea",
  SELECT_ITEM = "SelectItem",
  CREATE_ITEM = "CreateItem",
  SELECT_ISSUE = "SelectIssue",
  SELECT_LAYOUT = "SelectLayout",
  SELECT_MODEL = "SelectModel",
  SELECT_PERFORMED_WORK = "SelectPerformedWork",
  SELECT_WORK_ORDER = "SelectWorkOrder",
  SELECT_WORKSPACE = "SelectWorkspace",
  SELECT_ZONE = "SelectZone",
  TO_DO = "ToDo",
  USER_SETTINGS = "UserSettings",
  WORKSPACE = "Workspace",
  WORK_ORDER_CORRECTIVE = "WorkOrderCorrective",
  WORK_ORDER_REGULAR = "WorkOrderRegular",
  CREATE_WORK_ORDER = "CreateWorkOrder",
  ZONE = "Zone",
}

export enum DemoNamedPath {
  API_CALLS = "functionality/ApiCalls",
  BARCODE_READER = "functionality/BarcodeReader",
  BUTTONS = "elements/Buttons",
  CARDS = "elements/Cards",
  CHARTS = "elements/Charts",
  CHIPS = "elements/Chips",
  CUSTOM_DIRECTIVES = "functionality/Directives",
  CUSTOM_ICONS = "elements/CustomIcons",
  DATA_POINT = "elements/DataPoint",
  DATABASE = "functionality/Database",
  DEMO_INDEX = "DemoIndex",
  DIALOGS_AND_OVERLAYS = "elements/DialogsAndOverlays",
  EMPTY_STATES = "elements/EmptyStates",
  EXAMPLE_STORE = "functionality/ExampleStore",
  GENERAL_DIRECTIVES = "elements/GeneralDirectives",
  HEALTH_INDICATOR = "elements/HealthIndicator",
  IMAGE_GALLERY = "elements/ImageGallery",
  INPUTS = "elements/Inputs",
  ISSUES = "elements/Issues",
  KEYBOARD_READER = "functionality/KeyboardReader",
  MAIN_MENU = "elements/MainMenu",
  NFC_READER = "functionality/NfcReader",
  NOTIFICATIONS = "elements/Notifications",
  PRIORITY_LABELS = "elements/PriorityLabels",
  FILTERING_ELEMENTS = "elements/filtering",
  PROCEDURE_STEP = "elements/ProcedureStep",
  PROGRESS_INDICATOR = "elements/ProgressIndicator",
  RADIO_BUTTONS = "elements/RadioButtons",
  SEARCH_BAR = "functionality/SearchBar",
  SELECTS = "elements/Selects",
  SPECIAL_PURPOSE = "elements/SpecialPurpose",
  TABLE = "elements/Table",
  TABS = "elements/Tabs",
  TO_DO = "elements/ToDo",
  TOGGLE = "elements/Toggle",
  TOOLTIPS = "elements/Tooltips",
  TOP_NAVIGATION = "elements/TopNavigation",
  TYPOGRAPHY = "elements/Typography",
  UI_DEMO = "UIDemo",
}

export enum GlobalNamedPath {
  UNSUPPORTED_BROWSER = "unsupportedBrowser",
  NOT_FOUND = "404NotFound",
}
